import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLocaleData } from '@angular/common';
import localeEnGb from '@angular/common/locales/en-GB';
import localePt from '@angular/common/locales/pt';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

registerLocaleData(localeEnGb, 'en-GB');
registerLocaleData(localePt, 'pt-PT');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
